export const VALID_COUNTRY_PREFIXES = ["ae", "eg"];

/** Home URLs: /, /eg, /ae, /eg/ar, /ae/ar (root = before geo redirect) */
export const isHomeRoute = (pathname = "") => {
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length === 0) return true;
  if (segments.length === 1 && VALID_COUNTRY_PREFIXES.includes(segments[0])) return true;
  if (
    segments.length === 2 &&
    VALID_COUNTRY_PREFIXES.includes(segments[0]) &&
    segments[1] === "ar"
  ) {
    return true;
  }
  return false;
};

export const hasValidCountryPrefix = (pathname = "") => {
  const segments = pathname.split("/").filter(Boolean);
  return segments.length > 0 && VALID_COUNTRY_PREFIXES.includes(segments[0]);
};

/** Footer only after country route is ready and home finished loading */
export const shouldShowFooter = (pathname, isPageLoading) => {
  if (!hasValidCountryPrefix(pathname)) return false;
  if (isHomeRoute(pathname) && isPageLoading) return false;
  return true;
};
